import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsCampaigns = (from: string, to: string) => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.Campaigns(
			company.id,
			from,
			to,
		),
		queryFn: () => Api.GetMetaAdsCampaigns(from, to).then((r) => r.data),
		refetchInterval: 3600000,
	});
};
